import { render } from "./PrivacyAuth.vue?vue&type=template&id=8c82c7be"
import script from "./PrivacyAuth.vue?vue&type=script&lang=js"
export * from "./PrivacyAuth.vue?vue&type=script&lang=js"
script.render = render

export default script